/// prefix of the shop domain, excluding just the TLD‚
export const shop_domain_prefix = "https://shop.heringberlin";

export const regions = {
  EUROPE: "EUROPE",
  NORTH_AMERICA: "NORTH_AMERICA",
  INTERNATIONAL: "INTERNATIONAL",
};

export const headers = {
  locale: "x-hb-locale",
  region: "x-hb-region",
};

/**
 * This base64 image is a single 1x1 transparent pixel, used for story elements
 * that don't have an image assigned
 */
export const PLACEHOLDER_IMAGE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII";

export const BASE_URL = process.env.CF_PAGES_URL ?? "https://heringberlin.com";

export const PROD_URL = "https://heringberlin.com";

export const DEFAULT_BUILDER_LOCALE = "Default";
